import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({
  show = false,
  text = '',
  children = null,
  ariaLabel = 'Loading',
}) => {
  if (!show) return null;
  const hasText = Boolean(children) || Boolean(text);
  const accessibleLabel = ariaLabel || text || 'Loading';

  return (
    <div className="app-loading-overlay">
      <div className="app-loading-card" role="status" aria-live="assertive" aria-label={accessibleLabel}>
        <div className="app-loading-spinner" aria-hidden="true" />
        {hasText && (
          <div className="app-loading-text">
            {children || (text ? <p>{text}</p> : null)}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
